import React from 'react';
import PropTypes from 'prop-types';
import { withSnackbar } from 'notistack';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { injectIntl } from 'react-intl';

const CopyToClipboardAction = (props) => {
  const {
    text, notify, children, enqueueSnackbar, intl, notifyTimeout, ...others
  } = props;

  const handleOnCopy = (copiedText, succeeded) => {
    const messageId = succeeded ? 'copyToClipboard.succeeded' : 'copyToClipboard.failed';
    enqueueSnackbar(intl.formatMessage({ id: messageId }), {
      variant: succeeded ? 'info' : 'error',
      autoHideDuration: notifyTimeout,
    });
  };

  return (
    <CopyToClipboard
      text={text}
      onCopy={notify ? handleOnCopy : null}
    >
      {children}
    </CopyToClipboard>
  );
};

CopyToClipboardAction.defaultProps = {
  notify: true,
  notifyTimeout: 3000,
};

CopyToClipboardAction.propTypes = {
  notify: PropTypes.bool,
  notifyTimeout: PropTypes.number,
  text: PropTypes.string.isRequired,
  enqueueSnackbar: PropTypes.func.isRequired,
  children: PropTypes.instanceOf(Object).isRequired,
};

export default injectIntl(withSnackbar(CopyToClipboardAction));
